import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';


export default createReactClass({

   propTypes: {
      onOnline: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
      onOffline: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
      onChange: PropTypes.func,
   },

   getDefaultProps() {
      return {
         onOnline() {},
         onOffline() {},
         onChange() {},
      };
   },

   getInitialState() {
      return {
         online: window.navigator.onLine,
      };
   },

   componentDidMount() {
      window.addEventListener('online', this.handleChange);
      window.addEventListener('offline', this.handleChange);
   },

   componentWillUnmount() {
      window.removeEventListener('online', this.handleChange);
      window.removeEventListener('offline', this.handleChange);
   },

   handleChange() {
      window.xnat.checkIfHostIsReachable().then((online) => {
         this.setState({ online });
         this.props.onChange(online ? 'online' : 'offline');
         this.props[online ? 'onOnline' : 'onOffline']();
      });
   },

   close() {
      this.setState({ online: true });
   },

   render() {
      if (this.state.online) return null;

      const alert = {
         position: 'fixed',
         top: 50,
         left: '50%',
         transform: 'translateX(-50%)',
         zIndex: 100,
         padding: 30,
      };
      const button = {
         position: 'relative',
         right: -25,
         top: -25,
         padding: '5px 11px 8px',
      };

      const h1 = { marginTop: 0 };

      return (
         <Alert bsStyle="danger" style={alert}>
            <button type="button" className="close" onClick={this.close} style={button}><span>×</span></button>
            <h1 style={h1}>Sie sind anscheinend offline.</h1>
            <p className="lead">Versuchen Sie, die Verbindung zum Internet wieder herzustellen, um weiter arbeiten zu können.</p>
         </Alert>
      );
   },

});
